/*
 * File: c:\Users\j.mazat\Desktop\mobifleet_front\src\Hooks\useLocalStorage.tsx
 * Project: c:\Users\j.mazat\Desktop\mobifleet_front
 * Created Date: Thursday June 6th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Thursday June 6th 2024 11:30:30 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import { useState } from "react";

export const useLocalStorage = function <T>(keyName: string, defaultValue: T): [T, (newValue: T) => void] {
  const [storedValue, setStoredValue] = useState<T>(() => {
    try {
      const value = window.localStorage.getItem(keyName);
      if (value) {
        return JSON.parse(value);
      } else {
        window.localStorage.setItem(keyName, JSON.stringify(defaultValue));
        return defaultValue;
      }
    } catch (err) {
      return defaultValue;
    }
  });

  const setValue = (newValue: T) => {
    try {
      window.localStorage.setItem(keyName, JSON.stringify(newValue));
    } catch (err) {}
    setStoredValue(newValue);
  };
  return [storedValue, setValue];
};
